import { useRef } from "react"
import "./AboutMeSection.scss"
import {
  pic1Bg,
  pic1Decor,
  pic2Decor,
  pic3Bg,
  pic4Bg,
  pic1Lq,
  pic1Hq,
  pic2Lq,
  pic2Hq,
  pic3Hq,
  pic3Lq,
  pic4Lq,
  pic4Hq,
  mainLogo,
  aboutMePicLq,
  aboutMePicBg,
  aboutMePicDecor,
  aboutMePicLabel,
} from "../../../../assets/images"
import { useTextStorage, useImagePreload } from "../../../../hooks"
import { Button, ButtonSize } from "../../../../components/Button"
import { useNavigate } from "react-router-dom"

export const AboutMeSection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const pic1HqRef = useRef<HTMLImageElement>(null)
  const pic2HqRef = useRef<HTMLImageElement>(null)
  const pic3HqRef = useRef<HTMLImageElement>(null)
  const pic4HqRef = useRef<HTMLImageElement>(null)

  useImagePreload(pic1Hq, pic1HqRef)
  useImagePreload(pic2Hq, pic2HqRef)
  useImagePreload(pic3Hq, pic3HqRef)
  useImagePreload(pic4Hq, pic4HqRef)

  const handleButtonClick = () => {
    navigate("/about-me")
  }
  return (
    <div className="welcome-main-content">
      <div className="welcome-main-content--top-images">
        <img src={pic1Bg} alt="pic1-bg" className="top-images--pic1-bg" />
        <img
          src={pic1Decor}
          alt="pic1-decor"
          className="top-images--pic1-decor"
        />
        <img src={pic1Lq} alt="pic1-lq" className="top-images--pic1-lq" />
        <img
          ref={pic1HqRef}
          src={pic1Hq}
          alt="pic1-hq"
          className="top-images--pic1-hq"
        />

        <img
          src={pic2Decor}
          alt="pic2-decor"
          className="top-images--pic2-decor"
        />
        <img src={pic2Lq} alt="pic2-lq" className="top-images--pic2-lq" />
        <img
          ref={pic2HqRef}
          src={pic2Hq}
          alt="pic2-hq"
          className="top-images--pic2-hq"
        />

        <img
          src={mainLogo}
          alt="main logo for header"
          className="top-images--main-logo"
        />

        <img src={pic3Bg} alt="pic3-bg" className="top-images--pic3-bg" />
        <img src={pic3Lq} alt="pic3-lq" className="top-images--pic3-lq" />
        <img
          ref={pic3HqRef}
          src={pic3Hq}
          alt="pic3-hq"
          className="top-images--pic3-hq"
        />
        <img src={pic4Bg} alt="pic4-bg" className="top-images--pic4-bg" />
        <img src={pic4Lq} alt="pic4-lq" className="top-images--pic4-lq" />
        <img
          ref={pic4HqRef}
          src={pic4Hq}
          alt="pic4-hq"
          className="top-images--pic4-hq"
        />
      </div>
      <div className="welcome-main-content--about-me-section">
        <div className="about-me-section--image-container">
          <img
            src={aboutMePicBg}
            alt="about-me-bg"
            className="about-me-section--bg"
          />
          <img
            src={aboutMePicLq}
            alt="about-me-pic-lq"
            className="about-me-section--lq"
          />
          <img
            src={aboutMePicDecor}
            alt="about-me-pic-decor"
            className="about-me-section--pic-decor"
          />
          <img
            src={aboutMePicLabel}
            alt="about-me-pic-label"
            className="about-me-section--pic-label"
          />
        </div>
        <div className="about-me-section--content">
          <h2>{ts.pages.home.aboutMeSection.title}</h2>
          <p>{ts.pages.home.aboutMeSection.text}</p>
          <Button
            text={ts.pages.home.aboutMeSection.button}
            size={ButtonSize.MD}
            onClick={handleButtonClick}
          />
        </div>
      </div>
    </div>
  )
}
